import reducer from 'state/mrCollection/repeated-from/reducer';
import actions from 'state/mrCollection/repeated-from/actionCreators';
import selectors from 'state/mrCollection/repeated-from/selectors';

export { actions, selectors };
export default reducer;
